export const CompanyId = {
  NATURA: 1,
  AVON: 2,
}
